<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2023-02-24 11:16:41
 * @Description: 云渲染工具栏
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="tool tool_bottom">
    <div class="item">
      <div class="tag_bottom">
        <el-tag
          v-for="(tag, tagIndex) in tags"
          :key="tag.code"
          @click="tagsClick(tag.code, tag, tagIndex)"
          disable-transitions
        >
          <template v-if="tag.children">
            <el-popover
              placement="top"
              popper-class="tag_popover"
              :width="tag.hoverWidth"
              trigger="hover"
            >
              <div class="tag_popover__item">
                <el-tag
                  v-for="tagChild in tag.children"
                  :key="tagChild.code"
                  disable-transitions
                  @click="tagsClickChild(tagChild.code, tagChild, tag, tagIndex)"
                  class="mr-5px"
                >
                  <el-tooltip class="item" effect="dark" :content="tagChild.name" placement="top">
                    <span
                      class="iconfont text-20px text-white"
                      :class="
                        selectTagList.includes(tagChild.code)
                          ? `${tagChild.icon} tag-select`
                          : `${tagChild.icon} text-white`
                      "
                    ></span>
                  </el-tooltip>
                </el-tag>
              </div>
              <span
                slot="reference"
                class="iconfont text-20px text-white"
                :class="
                  selectTagList.includes(tag.code)
                    ? `${tag.icon} tag-select`
                    : `${tag.icon} text-white`
                "
              ></span>
            </el-popover>
          </template>
          <template v-else-if="tag.name === '分割线'">
            <el-divider class="h-full" direction="vertical"></el-divider>
          </template>
          <template v-else>
            <el-tooltip effect="dark" :content="tag.name" placement="top">
              <span
                class="iconfont text-20px"
                :class="
                  selectTagList.includes(tag.code)
                    ? `${tag.icon} tag-select`
                    : `${tag.icon} text-white`
                "
              ></span>
            </el-tooltip>
          </template>
        </el-tag>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tabBar',
  props: ['tags', 'activeTag', 'selectTagList', 'mainScreenFileName', 'disable'],
  data() {
    return {
      placement: {
        bottom: 'top',
        bottom_1: 'top',
        top: 'bottom',
      },
      changeActiveTag: false, // 是否切换tag
      lastClickTag: '', // 上一次点击的tag
    }
  },
  watch: {
    activeTag() {
      if (!this.disable) {
        this.changeActiveTag = true
        const index = _.findIndex(this.tags, ['code', this.activeTag])
        this.addClass(index, 'tag')
      }
    },
  },
  created() {
    if (this.activeTag && !this.disable) {
      this.changeActiveTag = true
      const index = _.findIndex(this.tags, ['code', this.activeTag])
      this.addClass(index, 'tag')
    }
  },
  methods: {
    // 给对象中各个属性重新赋值，可赋空，或者赋值另外一个对象中的相同键名对应的键值
    resetObjectValue(currentObj, otherObj = {}) {
      const currentObjKeys = Object.keys(currentObj)
      const otherObjKeys = Object.keys(otherObj)
      if (otherObjKeys.length) {
        currentObjKeys.forEach((curVal) => {
          if (otherObjKeys.includes(curVal)) {
            currentObj[curVal] = otherObj[curVal]
          }
        })
      } else {
        currentObjKeys.forEach((key) => {
          currentObj[key] = ''
        })
      }
      return currentObj
    },
    /**
     * @description: 悬浮框点击事件
     * @return {*}
     */
    tagsClickChild(code, tagChild, tag, index) {
      if (!this.disable) {
        tag = this.resetObjectValue(tag, tagChild)
        this.tagsClick(code, tagChild, index)
      }
    },
    tagsClick(code, tag) {
      if (!this.disable) {
        this.$emit('tagsClick', code, tag)
      }
    },
    /**
     * @description: 气泡动画
     * @param {*} index：目标元素索引
     * @param {*} info：只有父级tag有气泡动画，悬浮框无
     * @return {*}
     */
    addClass(index, info) {
      if (info === 'tag') {
        // 不存在激活的
        if (index === -1) {
          document.styleSheets[0].addRule('.tag_bottom::after', 'content: none;')
          return
        }
        this.changeActiveTag &&
          document.styleSheets[0].addRule(
            '.tag_bottom::after',
            ` left: ${index * 43.5 + 6}px; transition: left 1s;content: ''`
          )
        this.changeActiveTag = false
      }
    },
  },
}
</script>
<style lang="scss">
.el-popover.tag_popover {
  padding: 0;
  min-width: 20px;
  background: #0f101580;
  background-color: #d0efff;
  border: none;

  &[x-placement^='top'] .popper__arrow {
    border-top-color: #0f101580;

    &::after {
      border-top-color: #0f101580;
    }
  }
}
</style>
<style lang="scss" scoped>
.el-tag {
  display: flex !important;
  align-items: center;
  padding: 5px;
  background-color: #fff0;
  border: none;

  span {
    z-index: 10;
    width: 23.5px;
    height: 23px;
    text-align: center;
    line-height: 23px;
  }

  &.selected {
    color: red;
  }
}

.tag_popover {
  &__item {
    display: flex;
    align-items: center;
    padding: 5px;
    height: 40px;
    border-radius: 12px;

    .el-tag {
      display: flex !important;
      align-items: center;
      padding: 5px;
      margin: 5px 0;
      background-color: #fff0;
      border: none;

      & span {
        width: 23.5px;
        height: 23px;
        text-align: center;
        line-height: 23px;
      }

      &.actived {
        background: linear-gradient(#1167b1, #6db5da);
        background-color: #d0efff;
        border-radius: 50%;
      }
    }
  }
}

.tool {
  cursor: pointer;
  z-index: 100;

  &_bottom {
    bottom: 0;
    margin-right: 20px;
    height: 50px;

    .item {
      display: flex;
      align-items: center;
      height: 50px;

      .el-tag {
        padding: 5px;
        margin: 0 5px;

        span {
          width: 23.5px;
          height: 23px;
          text-align: center;
          line-height: 23px;
        }
      }
    }
  }

  .item {
    padding: 0 20px;
    background: #0f101580;
    border-radius: 100px;

    .tag_bottom {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
}

img {
  width: 3px;
  height: 23px;
}

::v-deep .el-divider--vertical {
  width: 1px;
  background: #fff;
}

.tag-select {
  color: #0082f7 !important;
}
</style>
